import { graphql, useStaticQuery } from "gatsby";

export const beerFragment = graphql`
    fragment Beer on BeerYaml {
        name
        category
        hr {
            publicURL
        }
        subhead
        meta_description
        info
        info_2
        info_3
        info_4
        colors {
            nav_bg
            nav_text
            background
            heading
            subheading
            text
            text_shadow
            text_bg
            seasonal
            finder
            didyouknow_bg
        }
        bg_image {
            publicURL
        }
        abv
        year
        sku
        slug
        order
        discontinued
        season {
            start
            end
        }
        image {
            childImageSharp {
                gatsbyImageData(layout: CONSTRAINED)
            }
        }
        meta_image {
            publicURL
        }
        video
        award {
            image {
                publicURL
            }
        }
        didyouknow {
            text
            image {
                publicURL
            }
        }
    }
`;

const allBeersQuery = graphql`
    query AllBeers {
        allBeerYaml(filter: { order: { gte: 0 } }, sort: { order: ASC }) {
            nodes {
                ...Beer
            }
        }
    }
`;

export function useAllBeers(): Queries.AllBeersQuery["allBeerYaml"]["nodes"] {
    const data = useStaticQuery(allBeersQuery);
    return data.allBeerYaml.nodes;
}
